import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from 'styles/pages/Attorneys/Summary/Paper.module.scss';

const Paper = ({ colorful, children, className: classProp }) => {
  const className = classNames(classes.root, { [classes.colorful]: colorful }, classProp);

  return <div className={className}>{children}</div>;
};

Paper.propTypes = {
  colorful: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Paper.defaultProps = {
  colorful: false,
  className: '',
};

export default Paper;
